module.exports = __webpack_public_path__ + "img/empty_order_list@2x.d43ba885.png";